// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarFactura_main__OX+9X","intro":"ModalEditarFactura_intro__kB4BD","input":"ModalEditarFactura_input__G9k8a"};